export const orderStatusOptions = [
  { value: 1001, label: 'Mới tạo' },
  { value: 1002, label: 'Chờ thanh toán' },
  { value: 1003, label: 'Chờ xác nhận' },
  { value: 1004, label: 'Chờ khớp' },
  { value: 1005, label: 'Hoàn tất' },
  { value: 1006, label: 'Đã hủy' },
  { value: 1007, label: 'Hệ thống đang xử lý' },
];
